/* Cart drawer free-gift progress bar — persistent controller.
   Loaded once (external asset), survives cart-drawer re-renders.
   Subscribes to the theme's cartUpdate pub/sub event AND patches fetch()
   as a robust fallback, so the bar always reflects the latest cart total
   regardless of how the add-to-cart call was triggered. */
(function () {
  var CONFETTI_FIRED_KEY = 'cnGiftUnlockedShown';

  function fmtMoney(paise, fmt) {
    var rupees = Math.ceil(paise / 100);
    var s = rupees.toLocaleString('en-IN');
    return (fmt || '₹{{amount}}').replace(/\{\{\s*amount[^}]*\}\}/g, s);
  }

  function drawerIsOpen() {
    var d = document.querySelector('cart-drawer');
    return !!(d && d.classList.contains('active'));
  }

  function render(totalPaise, opts) {
    var bar = document.getElementById('cn-gift-bar');
    if (!bar) return;

    var threshold = parseInt(bar.dataset.threshold, 10) || 349900;
    var fmt = bar.dataset.moneyFormat || '₹{{amount}}';
    var lockedTpl = bar.dataset.lockedText || 'Add [amount] more to unlock a Free Gift';
    var unlockedTpl = bar.dataset.unlockedText || "You have unlocked a Free Gift with this order";

    var textEl = bar.querySelector('#cn-gift-bar-text');
    var fillEl = bar.querySelector('#cn-gift-bar-fill');
    if (!textEl || !fillEl) return;

    var pct = Math.max(0, Math.min(100, (totalPaise / threshold) * 100));
    var wasUnlocked = bar.classList.contains('is-unlocked');
    fillEl.style.width = pct + '%';

    var unlocked = totalPaise >= threshold;
    if (unlocked) {
      bar.classList.add('is-unlocked');
      textEl.innerHTML = unlockedTpl;
      var alreadyShown = sessionStorage.getItem(CONFETTI_FIRED_KEY) === '1';
      // Only fire confetti on the LOCKED -> UNLOCKED transition (or first
      // paint if opts.allowConfetti), never repeatedly while already unlocked.
      if (opts && opts.allowConfetti && !alreadyShown && (!wasUnlocked || opts.force)) {
        fireConfettiSoon(bar);
        try { sessionStorage.setItem(CONFETTI_FIRED_KEY, '1'); } catch (e) {}
      }
    } else {
      bar.classList.remove('is-unlocked');
      var remaining = threshold - totalPaise;
      textEl.innerHTML = lockedTpl.replace('[amount]', '<b>' + fmtMoney(remaining, fmt) + '</b>');
      try { sessionStorage.removeItem(CONFETTI_FIRED_KEY); } catch (e) {}
    }
  }

  function renderFromServer(opts) {
    var bar = document.getElementById('cn-gift-bar');
    if (!bar) return;
    var seeded = parseInt(bar.dataset.current, 10);
    if (!isNaN(seeded)) render(seeded, { allowConfetti: false });
    fetch((window.routes ? routes.cart_url : '/cart') + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) { render(c.total_price, opts || { allowConfetti: true }); })
      .catch(function () {});
  }

  // Wait for layout to settle (drawer open transition, section re-render)
  // before measuring the bar, so the confetti canvas never gets sized 0x0.
  function fireConfettiSoon(bar) {
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var attempts = 0;
    function tryFire() {
      attempts++;
      var rect = bar.getBoundingClientRect();
      var w = rect.width || bar.offsetWidth;
      var h = rect.height || bar.offsetHeight;
      if ((w < 20 || h < 10) && attempts < 10) {
        setTimeout(tryFire, 80);
        return;
      }
      burst(bar, Math.max(w, 260), Math.max(h, 54));
    }
    // Double rAF ensures the browser has committed layout at least once
    // before we measure — fixes confetti not rendering during drawer-open.
    requestAnimationFrame(function () { requestAnimationFrame(tryFire); });
  }

  function burst(bar, width, height) {
    var canvas = bar.querySelector('#cn-gift-bar-confetti');
    if (!canvas) return;
    canvas.width = width;
    canvas.height = height;
    var ctx = canvas.getContext('2d');
    var colors = ['#ffc263', '#feeecb', '#b8860b', '#ffffff', '#ffd98a'];
    var pieces = [];
    for (var i = 0; i < 90; i++) {
      pieces.push({
        x: Math.random() * canvas.width,
        y: canvas.height + 8,
        vx: (Math.random() - 0.5) * 7,
        vy: -(6 + Math.random() * 7),
        size: 4 + Math.random() * 4,
        color: colors[(Math.random() * colors.length) | 0],
        rot: Math.random() * 6.28,
        vr: (Math.random() - 0.5) * 0.4
      });
    }
    var start = null;
    function frame(ts) {
      if (!start) start = ts;
      var elapsed = ts - start;
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      var alive = false;
      var life = Math.max(0, 1 - elapsed / 1600);
      pieces.forEach(function (p) {
        p.vy += 0.28;
        p.vx *= 0.99;
        p.x += p.vx;
        p.y += p.vy;
        p.rot += p.vr;
        if (life > 0) {
          alive = true;
          ctx.save();
          ctx.globalAlpha = life;
          ctx.translate(p.x, p.y);
          ctx.rotate(p.rot);
          ctx.fillStyle = p.color;
          ctx.fillRect(-p.size / 2, -p.size / 2, p.size, p.size * 0.6);
          ctx.restore();
        }
      });
      if (alive) requestAnimationFrame(frame);
      else ctx.clearRect(0, 0, canvas.width, canvas.height);
    }
    requestAnimationFrame(frame);
  }

  // Robust fallback: patch fetch() so ANY successful cart mutation
  // (/cart/add, /cart/change, /cart/update, /cart/clear) triggers a
  // re-render, regardless of whether the theme's own pub/sub event fires.
  function patchFetchForCartUpdates() {
    if (window.__cnGiftFetchPatched) return;
    window.__cnGiftFetchPatched = true;
    var origFetch = window.fetch;
    window.fetch = function () {
      var url = (arguments[0] && arguments[0].url) || arguments[0] || '';
      var isCartMutation = typeof url === 'string' && /\/cart\/(add|change|update|clear)(\.js)?/.test(url);
      var result = origFetch.apply(this, arguments);
      if (isCartMutation) {
        result.then(function (res) {
          if (res && res.ok) {
            setTimeout(function () { renderFromServer({ allowConfetti: true }); }, 220);
          }
          return res;
        }).catch(function () {});
      }
      return result;
    };
  }

  function init() {
    renderFromServer({ allowConfetti: false });
    patchFetchForCartUpdates();

    /* `PUB_SUB_EVENTS` is declared with `const` at the top level of
       assets/constants.js. A top-level `const` in a classic script lives in the
       global LEXICAL environment, NOT on `window` — so `window.PUB_SUB_EVENTS`
       is undefined and this guard silently failed, meaning the bar never
       subscribed to cart updates at all. `subscribe` is a function declaration,
       so it DOES land on window; that asymmetry is what hid the bug. */
    var events = typeof PUB_SUB_EVENTS !== 'undefined' ? PUB_SUB_EVENTS : null;
    var sub = typeof subscribe === 'function' ? subscribe : null;

    if (sub && events && events.cartUpdate) {
      sub(events.cartUpdate, function (event) {
        if (event && event.cartData && typeof event.cartData.total_price === 'number') {
          render(event.cartData.total_price, { allowConfetti: true });
        } else {
          renderFromServer({ allowConfetti: true });
        }
      });
    }

    document.addEventListener('click', function (e) {
      if (e.target.closest('#cart-icon-bubble, cart-drawer, a[href$="/cart"]')) {
        setTimeout(function () { renderFromServer({ allowConfetti: true }); }, 350);
      }
    }, { passive: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
